// Auto-generated from network-overview.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
/* hero constellation canvas — matches solutions/learn ix-hero animation,
   toned for the dark aubergine hero. */
(function(){
  var cv=document.getElementById('netOverviewHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!cv || reducedH) return;
  var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
  function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
  function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
    hubs=[]; var hn=Math.max(3,Math.round(W/520));
    for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
  var LINK=190;
  function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
    for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy;
      if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
    for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
    for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
      if(d<LINK){ var al=(1-d/LINK)*0.28; ctx.strokeStyle='rgba(232,217,184,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
        var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
        if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
          ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
    for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
      for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
        if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.22; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
      ctx.fillStyle='rgba(232,217,184,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
    for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(232,217,184,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
    if(running2) raf2=requestAnimationFrame(frame);
  }
  function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
  function stop2(){ running2=false; cancelAnimationFrame(raf2); }
  size(); build(); start2();
  window.addEventListener('resize',function(){ size(); build(); });
  if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
})();
/* count-up on scroll-in (matches homepage Proof of Success behaviour) */
(function(){
  var nums = document.querySelectorAll('.count[data-count]');
  if(!nums.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el){
    var target=parseFloat(el.getAttribute('data-count'));
    var prefix=el.getAttribute('data-prefix')||'', suffix=el.getAttribute('data-suffix')||'';
    if(isNaN(target)) return;
    if(reduced){ el.textContent=prefix+target+suffix; return; }
    var dur=1300,start=null;
    function ease(t){return 1-Math.pow(1-t,3);}
    function tick(now){ if(start===null)start=now; var p=Math.min(1,(now-start)/dur);
      el.textContent=prefix+Math.round(target*ease(p))+suffix;
      if(p<1)requestAnimationFrame(tick); else el.textContent=prefix+target+suffix; }
    el.textContent=prefix+'0'+suffix; requestAnimationFrame(tick);
  }
  if(!('IntersectionObserver' in window)){ nums.forEach(countUp); return; }
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){countUp(e.target);io.unobserve(e.target);}});},{threshold:0.4});
  nums.forEach(function(n){io.observe(n);});
})();

/* ---------- workflow stage: concept graphics in the homepage network style ----------
   uses the homepage draw recipe VERBATIM (same flat projection, strand alpha/
   width, tip-dots, density N=240) so it reads as the same living network. only
   the shape functions change, to express the three concepts:
   Protocol = hex token shell + rules spiralling in (core = the token).
   Ledger   = strands centre->6 chain nodes + node orbit rings, unison sync pulse
              (core = the record).
   AppStore = a woven mesh across a tile grid (dash-flow), tiles as orbit rings. */
(function(){
 function initWorkflow(canvasId, stageId, gridId){
  var cv=document.getElementById(canvasId);
  var stage=document.getElementById(stageId);
  var grid=document.getElementById(gridId);
  if(!cv||!stage||!grid) return;
  if(window.matchMedia('(max-width: 760px)').matches) return;
  var ctx=cv.getContext('2d');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cards=Array.prototype.slice.call(grid.querySelectorAll('.wcard'));

  var lava=[255,122,51];
  var W,H,DPR;
  function resize(){
    DPR=Math.min(window.devicePixelRatio||1,2);
    W=cv.clientWidth; H=cv.clientHeight;
    cv.width=W*DPR; cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0);
  }
  window.addEventListener('resize',resize); resize();

  var N=240, SEG=16;
  var P=[]; for(var i=0;i<N;i++){ P.push({u:i/N,j:Math.random(),seed:Math.random()*1000}); }
  function project(x,y,z){ var f=2.6/(2.6+z); return {x:W*0.5+x*W*0.32*f, y:H*0.52-y*H*0.42*f, d:(z+1)/2}; }
  function lerp(a,b,t){ return a+(b-a)*t; }

  // 6 ledger chain-node anchors
  // LEDGER: symmetrical ring of chain nodes around a centre
  var LCHAINS=8;
  function chainNode(k){ var a=k/LCHAINS*Math.PI*2; return [Math.cos(a)*0.74, Math.sin(a)*0.74*0.84, 0]; }
  // APPSTORE: bigger, denser grid (10x6), spread wider + neighbour pairs
  var COLS=10, ROWS=6, GSX=0.235, GSY=0.255, tiles=[];
  for(var rI=0;rI<ROWS;rI++) for(var cI=0;cI<COLS;cI++) tiles.push([ (cI-(COLS-1)/2)*GSX, (rI-(ROWS-1)/2)*GSY, 0 ]);
  var pairs=[];
  for(var a2=0;a2<tiles.length;a2++) for(var b2=a2+1;b2<tiles.length;b2++){
    var dx=tiles[b2][0]-tiles[a2][0], dy=tiles[b2][1]-tiles[a2][1];
    if(Math.hypot(dx,dy)<0.37) pairs.push([a2,b2]);   // 4-neighbour + diagonals
  }
  // small cube (the asset) — 12 edges into 8 corners
  var CUBE=[[0,1],[1,3],[3,2],[2,0],[4,5],[5,7],[7,6],[6,4],[0,4],[1,5],[2,6],[3,7]];
  function cubeCorner(i,hs){ return [ (i&1?hs:-hs), (i&2?hs:-hs), (i&4?hs:-hs) ]; }

  // ---- shape functions (signature matches homepage: u,j,s,seed,t) ----
  // PROTOCOL — small glowing cube (the asset); rule-strands orbit then spiral in
  // and absorb into it (rules embedding into the asset).
  function protocol(u,j,s,seed,t){
    var rot=t*0.25;                                  // shared spin (half speed)
    if(j<0.30){
      // the small cube itself: strands ride its 12 edges (small radius)
      var ei=Math.floor(u/0.30*12)%12, hs=0.16;
      var c0=cubeCorner(CUBE[ei][0],hs), c1=cubeCorner(CUBE[ei][1],hs), k=s;
      var x=c0[0]+(c1[0]-c0[0])*k, y=c0[1]+(c1[1]-c0[1])*k, z=c0[2]+(c1[2]-c0[2])*k;
      return [ x*Math.cos(rot)-z*Math.sin(rot), y, x*Math.sin(rot)+z*Math.cos(rot) ];
    }
    // rule-strands: orbit around, then spiral inward and FEED INTO the cube core
    var travel=(s + (t*0.225 + u*1.3))%1;            // 0 outside .. 1 fed in (half speed)
    var tin=travel*travel;                           // ease so they accelerate as they feed in
    var ang=u*Math.PI*2*3 + travel*3.2 + rot;        // more wind as it spirals in
    var rad=0.85*(1-tin)+0.0*tin;                    // all the way to the centre (feeds in)
    return [ Math.cos(ang)*rad, Math.sin(ang)*rad*0.86, Math.sin(ang*1.2)*rad*0.5 ];
  }
  // LEDGER — symmetrical: centre record + ring of chain nodes, spokes between.
  // (the travelling sync dot + thickening is drawn in the loop, see drawLedgerFx)
  function ledger(u,j,s,seed,t){
    var k=Math.floor(u*LCHAINS), nd=chainNode(k<0?0:(k>=LCHAINS?LCHAINS-1:k));
    if(j<0.55){
      // many short radial lines emanating from the centre, slowly rotating
      // (the homepage radiating-strand look), reaching toward the ring
      var a=u*Math.PI*2 + t*0.20;                    // dense spokes around, rotating
      var inner=0.10, outer=0.62+0.10*j;
      var r=inner+(outer-inner)*s;
      return [Math.cos(a)*r, Math.sin(a)*r*0.84, Math.sin(a)*0.05];
    } else if(j<0.82){
      // the unifying circular ring connecting the chain nodes (one record across)
      var R=0.74, ringSeg=Math.PI*2/LCHAINS;
      var a2=k*ringSeg + s*ringSeg + t*0.18;
      return [Math.cos(a2)*R, Math.sin(a2)*R*0.84, Math.sin(a2)*0.06];
    }
    // orbit ring at the chain node
    var a3=((u*LCHAINS)%1)*Math.PI*2 + s*Math.PI*2 + t*0.6, rr=0.10;
    return [nd[0]+Math.cos(a3)*rr, nd[1]+Math.sin(a3)*rr*0.9, Math.sin(a3)*rr];
  }
  // APPSTORE — big dense mesh; most strands flow along links, tiles get tiny orbits
  function appstore(u,j,s,seed,t){
    if(j<0.45 && pairs.length){                       // fewer moving packets now
      var pr=pairs[Math.floor(u*pairs.length)%pairs.length];
      var A=tiles[pr[0]], B=tiles[pr[1]];
      var base=(seed*0.137+t*0.5), phase=base-Math.floor(base);
      var pos=(phase-0.16+s*0.16); if(pos<0)pos+=1;
      return [A[0]+(B[0]-A[0])*pos, A[1]+(B[1]-A[1])*pos, Math.sin(pos*Math.PI)*0.10];
    }
    var ti=Math.floor(u*tiles.length)%tiles.length, T=tiles[ti];
    var a=((u*tiles.length)%1)*Math.PI*2 + s*Math.PI*2 + t;
    var rad=0.04;
    return [T[0]+Math.cos(a)*rad, T[1]+Math.sin(a)*rad, Math.sin(a)*rad];
  }
  var shapes=[protocol, ledger, appstore];
  var rotSpeed=[0.00050, 0.00035, 0.00050];
  var hasCore=[true, true, false];           // protocol cube core + ledger record core
  var flowIdx=2;                             // appstore = dash flow fade

  var from=0,to=0,mix=1,tStart=0,DUR=1500;
  function ease(t){ return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2; }
  function shapeWeight(idx,f,tt,e){ var w=0; if(f===idx)w+=(1-e); if(tt===idx)w+=e; return w; }
  function setShape(i){
    if(i===to) return;
    from=to; to=i; mix=0; tStart=performance.now();
    cards.forEach(function(c){ c.classList.toggle('active', +c.dataset.state===i); });
  }

  var running=false, raf=0;
  function drawFrame(now){
    ctx.clearRect(0,0,W,H);
    if(mix<1){ mix=Math.min(1,(now-tStart)/DUR); }
    var e=ease(mix), fA=shapes[from], fB=shapes[to];
    var rotA=now*rotSpeed[from], rotB=now*rotSpeed[to], col=lava;

    for(var i=0;i<N;i++){
      var p=P[i]; ctx.beginPath(); var started=false,lastD=0;
      for(var s=0;s<=SEG;s++){
        var sv=s/SEG, a=fA(p.u,p.j,sv,p.seed,rotA), b=fB(p.u,p.j,sv,p.seed,rotB);
        var x=lerp(a[0],b[0],e), y=lerp(a[1],b[1],e), z=lerp(a[2],b[2],e);
        var pr=project(x,y,z); lastD=pr.d;
        if(!started){ ctx.moveTo(pr.x,pr.y); started=true; } else ctx.lineTo(pr.x,pr.y);
      }
      var flowW=shapeWeight(flowIdx,from,to,e), ff=1;
      if(flowW>0.01){
        var bb=(p.seed*0.137+rotB*1.0), ph=bb-Math.floor(bb);
        var edge=Math.min(ph,1-ph)/0.18; ff=1-flowW*(1-Math.min(1,edge));
      }
      var alpha=(0.06+0.40*lastD)*ff;
      ctx.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+alpha+')';
      ctx.lineWidth=0.8+lastD*0.5; ctx.stroke();
      var ta=fA(p.u,p.j,1,p.seed,rotA), tb=fB(p.u,p.j,1,p.seed,rotB);
      var tp=project(lerp(ta[0],tb[0],e),lerp(ta[1],tb[1],e),lerp(ta[2],tb[2],e));
      ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+((0.18+0.6*tp.d)*ff)+')';
      ctx.beginPath(); ctx.arc(tp.x,tp.y,1.0+tp.d*1.4,0,7); ctx.fill();
    }

    // ledger: symmetrical centre -> ring of chain nodes; the centre emits a sync
    // dot to ONE chain at a time, sweeping around. the spoke thickens only at the
    // travelling dot's position (a moving thick segment), then thins again.
    var wL=shapeWeight(1,from,to,e);
    if(wL>0.01){
      var NC=LCHAINS;
      // which chain is currently being synced (sweeps one-at-a-time), + progress
      var cycle=(now*0.00075), idxF=cycle%NC, active=Math.floor(idxF), prog=idxF-active;
      for(var k=0;k<NC;k++){
        var nd=chainNode(k);
        var c0=project(0,0,0), c1=project(nd[0],nd[1],0);
        var isActive=(k===active);
        // base spoke; the active spoke lights up the WHOLE line brightly
        var lineA=isActive ? (0.55+0.4*Math.sin(prog*Math.PI))*wL : 0.18*wL;
        ctx.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+lineA+')';
        ctx.lineWidth=isActive ? 2.4 : 0.8;
        ctx.beginPath(); ctx.moveTo(c0.x,c0.y); ctx.lineTo(c1.x,c1.y); ctx.stroke();
        // chain node marker (brighter while its line is active)
        ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+((isActive?0.9:0.55)*wL)+')';
        ctx.beginPath(); ctx.arc(c1.x,c1.y,isActive?3.0:2.0,0,7); ctx.fill();
        // travelling sync dot on the active spoke
        if(isActive){
          var dp=prog, dx=nd[0]*dp, dy=nd[1]*dp, dpr=project(dx,dy,0);
          ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.95*wL)+')';
          ctx.beginPath(); ctx.arc(dpr.x,dpr.y,3.2,0,7); ctx.fill();
          if(dp>0.85){ var fl=(dp-0.85)/0.15;
            ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.6*wL*fl)+')';
            ctx.beginPath(); ctx.arc(c1.x,c1.y,5.5,0,7); ctx.fill(); }
        }
      }
      // central record glyph (3 bars) — the single canonical record
      var bw=0.10;
      for(var b=0;b<3;b++){ var yy=(b-1)*0.055; var bp1=project(-bw,yy,0),bp2=project(bw,yy,0);
        ctx.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.75*wL)+')'; ctx.lineWidth=1.3;
        ctx.beginPath(); ctx.moveTo(bp1.x,bp1.y); ctx.lineTo(bp2.x,bp2.y); ctx.stroke(); }
    }

    // appstore: grid links pulse/light up in fast-moving waves; tiles are circles.
    var wA=shapeWeight(2,from,to,e);
    if(wA>0.01){
      for(var L=0;L<pairs.length;L++){
        var A=tiles[pairs[L][0]], B=tiles[pairs[L][1]];
        var mx=(A[0]+B[0])/2, my=(A[1]+B[1])/2;        // wave sweeps diagonally, faster
        var wave=0.5+0.5*Math.sin(now*0.0034 - mx*5.0 - my*3.0);
        var ap=(0.06+0.34*wave)*wA;
        var p1=project(A[0],A[1],0), p2=project(B[0],B[1],0);
        ctx.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+ap+')';
        ctx.lineWidth=0.5+1.4*wave; ctx.beginPath(); ctx.moveTo(p1.x,p1.y); ctx.lineTo(p2.x,p2.y); ctx.stroke();
      }
      for(var n=0;n<tiles.length;n++){
        var T=tiles[n], pl=0.5+0.5*Math.sin(now*0.0034 - T[0]*5.0 - T[1]*3.0);
        var tc=project(T[0],T[1],0);
        // app = circle (ring + dot), bigger, softly pulsing
        ctx.strokeStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+((0.3+0.35*pl)*wA)+')'; ctx.lineWidth=1.0;
        ctx.beginPath(); ctx.arc(tc.x,tc.y,5.2,0,7); ctx.stroke();
        ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+((0.4+0.35*pl)*wA)+')';
        ctx.beginPath(); ctx.arc(tc.x,tc.y,1.8,0,7); ctx.fill();
      }
    }

    // central core for protocol(token) + ledger(record)
    var coreW=(hasCore[from]?(1-e):0)+(hasCore[to]?e:0);
    if(coreW>0.01){
      var c0=project(0,0,0), pulse=1+0.12*Math.sin(now*0.004), rad=(5+3*coreW)*pulse;
      var g=ctx.createRadialGradient(c0.x,c0.y,0,c0.x,c0.y,rad*2.4);
      g.addColorStop(0,'rgba('+col[0]+','+col[1]+','+col[2]+','+(0.85*coreW)+')');
      g.addColorStop(1,'rgba('+col[0]+','+col[1]+','+col[2]+',0)');
      ctx.fillStyle=g; ctx.beginPath(); ctx.arc(c0.x,c0.y,rad*2.4,0,7); ctx.fill();
      ctx.fillStyle='rgba('+col[0]+','+col[1]+','+col[2]+','+(0.95*coreW)+')';
      ctx.beginPath(); ctx.arc(c0.x,c0.y,rad,0,7); ctx.fill();
    }
    if(running && !reduced) raf=requestAnimationFrame(drawFrame);
  }

  cards.forEach(function(c){
    var i=+c.dataset.state;
    c.addEventListener('mouseenter',function(){ setShape(i); });
    c.addEventListener('focusin',function(){ setShape(i); });
  });
  grid.addEventListener('mouseleave',function(){ setShape(0); });
  setShape(0); cards[0].classList.add('active');

  if(reduced){ drawFrame(performance.now()); return; }
  if('IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !running){ running=true; raf=requestAnimationFrame(drawFrame); }
        else if(!e.isIntersecting && running){ running=false; cancelAnimationFrame(raf); }
      });
    },{threshold:0.05});
    io2.observe(stage);
  } else { running=true; raf=requestAnimationFrame(drawFrame); }
 }
 initWorkflow('workflowCanvas','workflowStage','wfGrid');
})();

/* ---------- problem: build the fragmented-vs-unified compare in on scroll ---------- */
(function(){
  var el=document.getElementById('pvCompare'); if(!el) return;
  if(!('IntersectionObserver' in window)){ el.classList.add('built'); return; }
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ el.classList.add('built'); io.disconnect(); } });
  },{threshold:0.3});
  io.observe(el);
})();
`;
